<template>
  <base-modal
    name="basic-modal"
    :visible="show"
    close-button
    close-outside
    @close="closeModal"
  >
    <template v-if="isAgreementSigned">
      <create-iframe
        v-model="widgetName"
        :is-update="isUpdate"
        @on-submit="toggleGeneratedPhase"
      />
    </template>

    <usage-agreement v-else @on-sign="signAgreement" />
  </base-modal>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import Cookies from 'js-cookie'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import BaseModal from '@emcd-shared/base-modal'
import UsageAgreement from '@/widgets/ModalCreateIframe/ui/UsageAgreement.vue'
import CreateIframe from '@/widgets/ModalCreateIframe/ui/CreateIframe.vue'

import { SWAP_LINKS_DISPATCHERS } from '@/shared/constants/store-constants/swapLinks'
import { EARN_ON_SWAP_ROUTE_KEY } from '@/shared/constants'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },

  isUpdate: {
    type: Boolean,
    default: false,
  },

  widgetToEdit: {
    type: Object,
    default: null,
  },
})

const emits = defineEmits(['update:modelValue', 'update-success'])

const store = useStore()
const router = useRouter()
const partnerId = store.state.auth.user.user_id

const isAgreementSigned = ref(getUsageAgreementCookie())
const widgetName = ref('')
const isGeneratedPhase = ref(false)

// Установим имя виджета, если он передан для редактирования
watch(
  () => props.widgetToEdit,
  (newValue) => {
    if (newValue && props.isUpdate) {
      widgetName.value = newValue.name
    }
  },
  { immediate: true }
)

const show = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  },
})

function closeModal() {
  widgetName.value = ''
  isGeneratedPhase.value = false
  show.value = false
}

function getUsageAgreementCookie() {
  return !!Cookies.get('usageAgreement')
}

function signAgreement() {
  Cookies.set('usageAgreement', true)
  isAgreementSigned.value = true
}

function toggleGeneratedPhase(val) {
  isGeneratedPhase.value = !!val
  if (isGeneratedPhase.value) {
    if (props.isUpdate && props.widgetToEdit) {
      updateWidget(widgetName, props.widgetToEdit)
    } else {
      createLink(widgetName)
    }
  }
}

async function createLink(name) {
  try {
    const { success } = await store.dispatch('swapLinks/createSwapApp', {
      appName: name.value.trim(),
      partnerId: null,
    })

    if (!success) {
      return
    }

    const appsList = await store.dispatch(SWAP_LINKS_DISPATCHERS.getSwapApps)

    if (appsList && appsList.apps && appsList.apps.length) {
      const createdApp = appsList.apps.find(
        (app) => app.name === name.value.trim()
      )
      if (createdApp && createdApp.app) {
        router.push({
          name: EARN_ON_SWAP_ROUTE_KEY.WIDGET,
          params: { id: createdApp.app },
        })
        closeModal()
      } else {
        isGeneratedPhase.value = false
      }
    } else {
      isGeneratedPhase.value = false
    }
  } catch (error) {
    console.error('Failed to create swap app:', error)
    isGeneratedPhase.value = false
  }
}

async function updateWidget(name, widget) {
  try {
    const response = await store.dispatch(
      SWAP_LINKS_DISPATCHERS.updateSwapApp,
      {
        appName: widget.uid,
        requestData: { name: name.value.trim() },
        partnerId: partnerId,
        skipGetApps: true,
      }
    )

    emits('update-success', response)

    closeModal()
  } catch (error) {
    isGeneratedPhase.value = false
  }
}
</script>
